// Simply add " canActivate: [RoleGuardService], data: { role: 'YourRoleName' }, " to your route on app.routes.ts
import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ConfigurationService, IAppSettings } from '../services/configuration/configuration.service';

@Injectable({ providedIn: 'root' })
export class RoleGuardService implements CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    private configuration: ConfigurationService<IAppSettings>
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const roles: string[] = route.data['roles'];

    return this.configuration.get('Role').pipe(
      switchMap(userRole => {
        let shouldActivate = false;
        for (let i = 0; i < roles.length; i++) {
          if (roles[i].includes(userRole)) {
            shouldActivate = true;
          }
        }

        if (!shouldActivate) {
          this.router.navigate(['/access-denied']);

          return of(false);
        }

        return of(true);
      })
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
